import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from 'elem/compCommon/EFPicture';
import { Pagination } from 'swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let animationId: any = null;
const duration = 4000; // 动画持续时间（毫秒）
let initAniTime = 0; // 开启动画的时间
let aniFrameTime = 0; // 每一帧动画进入时间
let pause = false; // 用户交互鼠标移入是否暂停
let percent = 0; // 进度
let replay = false; // 暂停后继续播放
let enterTime = 0; // 鼠标移入时间
let leaveTime = 0; // 鼠标移出时间
export default function ProductBreifGuideSwiper({ cls, swiperArr = [], langKey = '' }: any) {
    const { useLang, useState, useEffect, gtm } = useGlobal();
    const { t } = useLang(langKey);

    const [swiper, setSwiper] = useState<any>({});

    // 轮播变化埋点
    const slideChangeHandle = (index: number) => {
        initAniTime = 0;
        if (animationId) {
            cancelAnimationFrame(animationId);
            animationId = null;
        }
        doAnimate();
        const item = swiperArr[index - 1];
        if (item) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'view_banner',
                banner_name: item.title,
                position: `carousel banner_${index}`,
                nonInteraction: false,
            });
        }
    };

    const hanldleMouseEnter = () => {
        if (swiper) {
            pause = true;
            replay = false;
            enterTime = new Date().getTime();
            if (animationId) {
                cancelAnimationFrame(animationId);
            }
        }
    };

    const hanldleMouseLeave = () => {
        if (swiper) {
            pause = false;
            replay = true;
            leaveTime = new Date().getTime();
            doAnimate();
        }
    };

    // 执行动画的函数
    const animate = (_currentTime: number) => {
        if (!initAniTime) {
            initAniTime = new Date().getTime();
        }
        aniFrameTime = new Date().getTime();
        const element = document.querySelector(
            `${cls ? `.${cls} ` : ''}.product-brief-guide-swiper .swiper-box .swiper-pagination .swiper-pagination-bullet-active .after`,
        ) as HTMLSpanElement;

        // 计算动画进度（0 到 1 之间的值）
        if (element && swiper) {
            if (!pause) {
                if (replay) {
                    initAniTime = initAniTime + (leaveTime - enterTime);
                    leaveTime = 0;
                    enterTime = 0;
                    replay = false;
                }
                const judgeTime = aniFrameTime - initAniTime;
                const progress = Math.min(judgeTime / duration, 1);
                percent = progress;
                element.style.transform = `translateX(-${100 - 100 * percent}%)`;
                if (judgeTime >= duration) {
                    try {
                        swiper && swiper.slideNext && swiper.slideNext();
                    } catch (e: any) {}
                }
            } else {
                element.style.transform = `translateX(-${100 - 100 * percent}%)`;
            }
            requestAnimationFrame(animate);
        }
    };

    const doAnimate = () => {
        if (animationId) cancelAnimationFrame(animationId);
        animationId = requestAnimationFrame(animate);
    };

    useEffect(() => {
        if (typeof window !== 'undefined' && swiper && swiperArr?.length > 0) {
            // 启动动画
            doAnimate();
        }
    }, [swiper]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const eles: any = document.querySelectorAll(
                `${cls ? `.${cls} ` : ''}.product-brief-guide-swiper .swiper-box .swiper-pagination .swiper-pagination-bullet`,
            );
            for (let i = 0; i < eles?.length; i++) {
                const existedSpan = eles[i].querySelector('.after') as HTMLSpanElement;
                if (!existedSpan) {
                    const span = document.createElement('span');
                    span.setAttribute('class', 'after');
                    eles[i].appendChild(span);
                }
            }
        }
    }, []);

    return (
        <section className={`product-brief-guide-swiper ${css['product-brief-guide-swiper']}`}>
            <Swiper
                className={`swiper-box ${swiperArr?.length > 1 ? '' : 'single'}`}
                modules={[Pagination]}
                spaceBetween={0}
                loop={swiperArr?.length > 1}
                slidesPerView={'auto'}
                initialSlide={0}
                pagination={swiperArr?.length > 1 ? { clickable: true } : false}
                onSlideChange={(swiper) => slideChangeHandle(swiper.activeIndex)}
                onSwiper={(swiperIns: any) => setSwiper(swiperIns)}
            >
                {swiperArr?.map((item: any, k: number) => (
                    <SwiperSlide className={`swiper-item`} key={k} onMouseEnter={hanldleMouseEnter} onMouseLeave={hanldleMouseLeave}>
                        {(String(item).endsWith('.mp4') || String(item).endsWith('.webm') || String(item?.video).endsWith('.mp4') || String(item?.video).endsWith('.webm')) ? (
                            <video
                                src={item?.video || item}
                                muted
                                autoPlay
                                loop
                                playsInline
                                preload="auto"
                                width="100%"
                                height="100%"
                                poster={item?.poster}
                                aria-label={langKey ? t('brief_guide.info.title') : 'swiper video'}
                            />
                        ) : (
                            <EFPicture
                                src={`${item?.img}`}
                                srcPad={`${item?.imgPad || item?.img}`}
                                srcMobile={`${item?.imgMobile || item?.imgPad || item?.img}`}
                                alt={langKey ? t('brief_guide.info.title') : 'swiper image'}
                            />
                        )}
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
}
